import { render, staticRenderFns } from "./followUpWaiting.vue?vue&type=template&id=9f1adbea&scoped=true"
import script from "./followUpWaiting.vue?vue&type=script&lang=js"
export * from "./followUpWaiting.vue?vue&type=script&lang=js"
import style0 from "./followUpWaiting.vue?vue&type=style&index=0&id=9f1adbea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1adbea",
  null
  
)

export default component.exports